document.addEventListener("DOMContentLoaded", function () {
  const filterButtons = document.querySelectorAll(".filter-button");
  const logoItems = document.querySelectorAll(".logo-item");
  const noCollectionsMessage = document.getElementById("no-collections-message");

  filterButtons.forEach(button => {
    button.addEventListener("click", function () {
      const selectedLetter = this.dataset.letter;
      let hasCollections = false;

      if (selectedLetter === "all") {
        logoItems.forEach(item => {
          item.style.display = "block";
        });
        hasCollections = logoItems.length > 0;
      } else {
        logoItems.forEach(item => {
          if (item.dataset.letter === selectedLetter) {
            item.style.display = "block";
            hasCollections = true;
          } else {
            item.style.display = "none";
          }
        });
      }

      // Show/hide no collection message
      if (hasCollections) {
        noCollectionsMessage.classList.add("hidden");
      } else {
        noCollectionsMessage.classList.remove("hidden");
      }

      // Toggle active class on buttons
      filterButtons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");
    });
  });
});
